import React from 'react';
import { useTheme } from '../themes/ThemeProvider';

const AboutPage: React.FC = () => {
  const { branding } = useTheme();
  const about = branding?.about;
  const story = about?.story;
  const storeName = branding?.store?.name || branding?.name || 'Our Store';
  const storeDescription =
    branding?.store?.description || branding?.description;

  const title = story?.title || `About ${storeName}`;
  const sections = story?.sections;
  const tagline = story?.tagline;

  return (
    <div
      className="container mx-auto px-lg py-3xl"
      style={{ maxWidth: 'var(--container-max-width)' }}
      data-testid="about-page"
    >
      <div className="mb-3xl text-center">
        <h1 className="font-serif text-4xl md:text-5xl font-semibold text-primary mb-md">
          {title}
        </h1>
        {tagline && (
          <p className="text-text-secondary text-base md:text-lg max-w-2xl mx-auto leading-relaxed italic">
            {tagline}
          </p>
        )}
      </div>

      <div className="max-w-3xl mx-auto">
        {sections && sections.length > 0 ? (
          <div className="flex flex-col gap-2xl">
            {sections.map((section, idx) => (
              <section key={idx} className="flex flex-col gap-md">
                <h2 className="font-serif text-2xl md:text-3xl font-semibold text-primary">
                  {section.heading}
                </h2>
                <p className="text-text-secondary text-base md:text-lg leading-relaxed">
                  {section.content}
                </p>
              </section>
            ))}
          </div>
        ) : (
          storeDescription && (
            <p className="text-text-secondary text-base md:text-lg leading-relaxed text-center">
              {storeDescription}
            </p>
          )
        )}
      </div>
    </div>
  );
};

export default AboutPage;
